<template>
  <div class="row">
    <div class="col-xs-12 text-center"  style="margin: 20px 0">
      <div class="btn-group">
        <button class="btn btn-info btn-sm" type="button" :class="{'btn-outline': interval !== 'Monthly'}" @click="interval = 'Monthly'">Monthly</button>
        <button class="btn btn-info btn-sm" type="button" :class="{'btn-outline': interval !== 'Annually'}" @click="interval = 'Annually'">Annually</button>
      </div>
    </div>

    <div class="col-xs-6 col-md-4 col-lg-3">
      <div class="hpanel hblue">
        <div class="panel-body table-responsive"  style="margin-top: 209px">
          <table class="table" style="margin-bottom: 10px">
            <thead>
            <tr>
              <th>Searches / month</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Science</td>
            </tr>
            <tr>
              <td>Patent</td>
            </tr>
            <tr>
              <td>Company</td>
            </tr>
            </tbody>
          </table>
          <table class="table" style="margin-bottom: 10px">
            <thead>
            <tr>
              <th>Step-by-step innovation</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>State Of The Art</td>
            </tr>
            <tr>
              <td>Problem Solving</td>
            </tr>
            <tr>
              <td>Tech Transfer</td>
            </tr>
            </tbody>
          </table>
          <table class="table" style="margin-bottom: 10px">
            <thead>
            <tr>
              <th>Project</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Storage</td>
            </tr>
            <tr>
              <td>Collaborative</td>
            </tr>
            </tbody>
          </table>
          <table class="table" style="margin-bottom: 0">
            <tbody>
            <tr>
              <th>Support</th>
            </tr>
            </tbody>
          </table>
          <table class="table" style="margin-bottom: 0">
            <tbody>
            <tr>
              <th>Mailing campaigns to Experts & Cies</th>
            </tr>
            </tbody>
          </table>
          <table class="table" style="margin-bottom: 0">
            <tbody>
            <tr>
              <th>Interactions recording</th>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <carousel v-if="plans" class="col-xs-6 col-md-8 col-lg-9"
              :perPageCustom="[[0, 1], [1100, 2], [1400, 3]]"
              :perPage="5" :navigationEnabled="true" :loop="true" :autoplay="true">
      <template v-for="(plan, key) in plans"  v-if="plans.length && currentPlan && plan">

        <template v-if="plan.amount === 0 || ((interval === 'Monthly' && plan.interval === 'month') || (interval === 'Annually' && plan.interval === 'year'))">
          <slide class="" :key="key" :data-index="key" style="padding: 0 15px">
            <div class="hpanel hblue" >
              <div class="panel-heading hbuilt text-center">
                <h4 class="font-bold">
                  <span v-if="currentPlan.id === plan.id" class="label label-info" style="font-size: 10px">Current</span>
                  {{plan.productObject.name}}
                </h4>
              </div>
              <div class="panel-body " style="height: 150px">
                <p class="text-center m-b-xs" v-if="plans" >
                  <template v-if="plan.amount === 0">
                    <div class="font-bold" style="font-size: 20px;margin-bottom: 15px">FREE</div>
                  </template>
                  <template v-else>
                    <template v-if="interval === 'Monthly'">
                      <div class="font-bold" style="font-size: 20px"><template v-if="plan.productObject.name === 'Silver'">{{0| toCurrency}} then</template> {{plan.monthly | toCurrency}}</div>
                      <div style="font-size: 10px">per month billed month-to-month</div>

                    </template>
                    <template v-else-if="interval === 'Annually'">
                      <div class="font-bold" style="font-size: 20px">{{plan.annually | toCurrency}}</div>
                      <div style="font-size: 10px">per month billed annually</div>
                    </template>
                  </template>
                </p>
                <p class="text-center" v-if="plan.productObject">
                  {{plan.productObject.metadata['description']}}
                </p>
                <p class="m-t-xs m-b">
                  <template v-if="$user.isFreeTrial()">
                    <router-link :to="{name: 'Register'}" class="btn btn-info btn-outline btn-sm m-t-xs btn-block">Register</router-link>
                  </template>
                  <template v-else-if="currentPlan !== null">
                    <template v-if="currentPlan.id === plan.id">
                      <router-link :to="{name: 'Profile'}" class="btn btn-info btn-outline btn-sm m-t-xs btn-block">Review</router-link>
                    </template>
                    <template v-else>
                      <button v-if="plan.productObject.name === 'Basic'" class="btn btn-info btn-sm m-t-xs btn-block" @click="subscribe(plan)">Back to basic</button>
                      <button v-else-if="plan.productObject.name === 'Silver' && !$user.trialIsUsed()" class="btn btn-info btn-sm m-t-xs btn-block" @click="subscribe(plan)">Start free trial</button>
                      <button v-else class="btn btn-info btn-sm m-t-xs btn-block" @click="subscribe(plan)">Subscribe</button>
                    </template>
                  </template>
                </p>
              </div>
              <div class="panel-body ">
                <table class="table" style="margin-top: 34px">
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'">25</template>
                      <template v-else-if="plan.productObject.name === 'Diamond'">100</template>
                      <template v-else>25</template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'">25</template>
                      <template v-else-if="plan.productObject.name === 'Diamond'">100</template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'">25</template>
                      <template v-else-if="plan.productObject.name === 'Diamond'">100</template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <table class="table" style="margin-top: 43px">
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'"><i class="fa fa-check"></i></template>
                      <template v-else-if="plan.productObject.name === 'Diamond'"><i class="fa fa-check"></i></template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'"><i class="fa fa-check"></i></template>
                      <template v-else-if="plan.productObject.name === 'Diamond'"><i class="fa fa-check"></i></template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'"><i class="fa fa-check"></i></template>
                      <template v-else-if="plan.productObject.name === 'Diamond'"><i class="fa fa-check"></i></template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <table class="table" style="margin-top: 43px;margin-bottom: 10px" >
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'">2</template>
                      <template v-else-if="plan.productObject.name === 'Diamond'">5</template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'"><i class="fa fa-check"></i></template>
                      <template v-else-if="plan.productObject.name === 'Diamond'"><i class="fa fa-check"></i></template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <table class="table" >
                  <tbody>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'">Chat, Online academy</template>
                      <template v-else-if="plan.productObject.name === 'Diamond'">Chat, Online academy</template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'"><i class="fa fa-minus"></i></template>
                      <template v-else-if="plan.productObject.name === 'Diamond'"><i class="fa fa-check"></i></template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <template v-if="plan.productObject.name === 'Silver'"><i class="fa fa-minus"></i></template>
                      <template v-else-if="plan.productObject.name === 'Diamond'"><i class="fa fa-check"></i></template>
                      <template v-else><i class="fa fa-minus"></i></template>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="text-center">
                  <template v-if="$user.isFreeTrial()">
                    <router-link :to="{name: 'Register'}" class="btn btn-info btn-outline btn-sm m-t-xs btn-block">Register</router-link>
                  </template>
                  <template v-else-if="currentPlan !== null">
                    <template v-if="currentPlan.id === plan.id">
                      <router-link :to="{name: 'Profile'}" class="btn btn-info btn-outline btn-sm m-t-xs btn-block">Review</router-link>
                    </template>
                    <template v-else>
                      <button v-if="plan.productObject.name === 'Basic'" class="btn btn-info btn-sm m-t-xs btn-block" @click="subscribe(plan)">Back to basic</button>
                      <button v-else-if="plan.productObject.name === 'Silver' && !$user.trialIsUsed()" class="btn btn-info btn-sm m-t-xs btn-block" @click="subscribe(plan)">Start free trial</button>
                      <button v-else class="btn btn-info btn-sm m-t-xs btn-block" @click="subscribe(plan)">Subscribe</button>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </slide>
        </template>
      </template>
    </carousel>
  </div>

</template>

<style>
.VueCarousel-dot-container {
  margin-top: 0 !important;
}
.VueCarousel-navigation-prev {
  left: 15px !important;
}
.VueCarousel-navigation-next {
  right: 15px !important;
}
</style>
<script>

import {Carousel, Slide} from 'vue-carousel'
import VueLadda from 'vue-ladda'
import Payment from './Payment'

const stripe = Stripe(process.env.STRIPE)

export default {
  components: {Payment, Carousel, Slide, VueLadda},
  name: 'ProductSelectionIndividual',
  data () {
    return {
      products: [],
      plans: [],
      interval: 'Monthly',
      currentPlan: null
    }
  },
  methods: {
    subscribe: function (plan) {
      if (plan.productObject.name === 'Silver' && !this.$user.trialIsUsed()) {
        localStorage.setItem('trial', true)
      } else {
        localStorage.removeItem('trial')
      }
      this.$emit('updateSelectedPlan', Object.assign({}, plan))
      this.$emit('updateSelectedProduct', Object.assign({}, plan.product))
    },
    setPlanPrice: function () {
      this.plans.forEach((plan) => {
        plan.productObject = this.products.find((product) => {
          if (plan.product === product.id) {
            return product
          }
        })

        let price = '0'

        if (parseInt(plan.amount) !== 0) {
          price = plan.amount
        }

        price = price.toString()

        if (price !== '0') {
          price = price.slice(0, price.length - 2) + '.' + price.slice(price.length - 2, price.length)
          price = parseFloat(price) + ((parseFloat(price) * 20) / 100)
        }

        if (plan.interval === 'month') {
          plan.monthly = parseFloat(price)
        } else if (plan.interval === 'year') {
          plan.annually = parseFloat(price) / 12
        }
      })
    },
    setProductSelected: function () {
      let targetPlan = localStorage.getItem('register_plan')

      let planSelected = null

      this.plans.forEach((plan) => {
        if (plan.productObject && plan.productObject.name === 'Silver' && targetPlan === 'silver') {
          if (plan.interval === 'year' && this.interval === 'Annually') {
            planSelected = plan
          } else if (plan.interval === 'month' && this.interval === 'Monthly') {
            planSelected = plan
          }
        } else if (plan.productObject && plan.productObject.name === 'Diamond' && targetPlan === 'diamond') {
          if (plan.interval === 'year' && this.interval === 'Annually') {
            planSelected = plan
          } else if (plan.interval === 'month' && this.interval === 'Monthly') {
            planSelected = plan
          }
        }
      })

      localStorage.removeItem('register_plan')
      localStorage.removeItem('register_interval')

      if (planSelected !== null) {
        this.subscribe(planSelected)
      }
    }
  },
  beforeMount () {
    let interval = localStorage.getItem('register_interval')

    if (typeof interval !== 'undefined' && interval !== null) {
      if (interval === 'y') {
        this.interval = 'Annually'
      } else {
        this.interval = 'Monthly'
      }
    }

    this.axios.get('payment/plan').then((response) => {
      this.currentPlan = response.data
    })

    this.axios.all([this.axios.get('https://api.stripe.com/v1/products?active=true', {
      headers: {'Authorization': 'bearer ' + process.env.STRIPE_SECRET}
    }), this.axios.get('https://api.stripe.com/v1/plans?active=true', {
      headers: {'Authorization': 'bearer ' + process.env.STRIPE_SECRET }
    })]).then(this.axios.spread((resultProducts, resultPlans) => {
      this.products = resultProducts.data.data

      this.plans = resultPlans.data.data

      this.plans.sort((plan1, plan2) => {
        return parseInt(plan1.amount) - parseInt(plan2.amount)
      })

      this.setPlanPrice()

      this.setProductSelected()
    }))
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/ProductSelectionIndividual.vue